import classNames from 'classnames';
import { useCssInJs } from "../../../../../hooks";
import { getStyles } from "./styles";
import { Divider } from 'antd';
import { DictText } from "../../../../../components/Form/Text";
import { noop } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var STATUS_COLOR_MAP = {
  2: '#1865E6',
  // 审批中
  1: '#FF8298',
  // 待处理
  0: '#B4B4B4',
  // 未开始
  4: '#2F3C65',
  // 中止
  3: 'rgba(0, 199, 119, 0.60)' // 已处理
};
function Header(props) {
  var prefix = 'legacy-form-header';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var data = props.data,
    mode = props.mode;
  var taskCode = data.taskCode,
    taskName = data.taskName,
    taskStatus = data.taskStatus,
    principalUsers = data.principalUsers,
    deadlineTime = data.deadlineTime,
    willTimeout = data.willTimeout,
    timeoutDuration = data.timeoutDuration,
    completeTime = data.completeTime,
    doingTimeDuration = data.doingTimeDuration,
    leftTimeDuration = data.leftTimeDuration;
  var showDoingText = Boolean(doingTimeDuration || leftTimeDuration);
  if (mode === 'editable') {
    return null;
  }
  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: classNames(prefix, hashId),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "header",
      children: [/*#__PURE__*/_jsx("div", {
        className: "title",
        children: taskName
      }), /*#__PURE__*/_jsxs("div", {
        className: "content",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "line",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "item",
            children: [/*#__PURE__*/_jsx("div", {
              className: "item-key",
              children: "\u4EFB\u52A1\u72B6\u6001"
            }), /*#__PURE__*/_jsxs("div", {
              className: "item-value",
              children: [/*#__PURE__*/_jsx("div", {
                className: "statusDot",
                style: {
                  backgroundColor: taskStatus && STATUS_COLOR_MAP[taskStatus]
                }
              }), /*#__PURE__*/_jsx(DictText, {
                dictType: "cbs_task_status",
                value: taskStatus
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "item",
            children: [/*#__PURE__*/_jsx("div", {
              className: "item-key",
              children: "\u4EFB\u52A1\u7F16\u7801"
            }), /*#__PURE__*/_jsx("div", {
              className: "item-value",
              children: taskCode
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "item",
            children: [/*#__PURE__*/_jsx("div", {
              className: "item-key",
              children: "\u4EFB\u52A1\u5904\u7406\u4EBA"
            }), /*#__PURE__*/_jsx("div", {
              className: "item-value",
              children: /*#__PURE__*/_jsxs("div", {
                className: "person-list",
                onClick: noop,
                children: [/*#__PURE__*/_jsx("div", {
                  className: "person-text",
                  children: principalUsers === null || principalUsers === void 0 ? void 0 : principalUsers.map(function (item) {
                    return "".concat(item.userName).concat(item.title);
                  }).join('')
                }), principalUsers !== null && principalUsers !== void 0 && principalUsers.length ? /*#__PURE__*/_jsxs("div", {
                  className: "person-addon",
                  children: ["\u5171", principalUsers.length, "\u4EBA"]
                }) : null]
              })
            })]
          })]
        }), showDoingText || completeTime ? /*#__PURE__*/_jsx("div", {
          className: "line",
          children: /*#__PURE__*/_jsxs("div", {
            className: "item",
            children: [/*#__PURE__*/_jsx("div", {
              className: "item-key",
              children: "\u4EFB\u52A1\u65F6\u6548"
            }), /*#__PURE__*/_jsxs("div", {
              className: "item-value",
              children: [showDoingText ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [doingTimeDuration ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("div", {
                    children: doingTimeDuration
                  }), /*#__PURE__*/_jsx(Divider, {
                    type: "vertical"
                  })]
                }) : null, leftTimeDuration ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("div", {
                    children: leftTimeDuration
                  }), /*#__PURE__*/_jsx(Divider, {
                    type: "vertical"
                  })]
                }) : null]
              }) : null, completeTime ? /*#__PURE__*/_jsx("div", {
                children: completeTime
              }) : /*#__PURE__*/_jsxs(_Fragment, {
                children: [deadlineTime ? /*#__PURE__*/_jsx("div", {
                  children: deadlineTime
                }) : null, willTimeout ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Divider, {
                    type: "vertical"
                  }), /*#__PURE__*/_jsx("div", {
                    className: "textWarn",
                    children: "\u5373\u5C06\u8D85\u65F6"
                  })]
                }) : null, timeoutDuration ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Divider, {
                    type: "vertical"
                  }), /*#__PURE__*/_jsx("div", {
                    className: "textDanger",
                    children: timeoutDuration
                  })]
                }) : null]
              })]
            })]
          })
        }) : null]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "sectionSplit"
    })]
  }));
}
export default Header;